import React, { useState, useEffect } from "react";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import {createExpense,getAllExpenses} from "../../../../redux/slices/sliceActions";

const CreateExpenseModal = ({ setShowModal,setShowToast,setToastType }) => {
  // redux methods
  const dispatch = useDispatch();
  const { tenants, properties, waterinvoices } = useSelector(
    (state) => state.landlordslice
  );

  // apartment  variables
  const [propertyChoices, setPropertyChoices] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState("Select Apartment");
  useEffect(() => {
    if (Object.keys(properties).length > 0) {
      setPropertyChoices([...properties.map((property) => property.name)]);
    }
  }, [properties]);

  const [houseChoices, setHouseChoices] = useState([" Select House"]);
  useEffect(() => {
    if (selectedProperty !== "Select Apartment") {
      const selectedPropertyObj = properties.find(
        (property) => property.name === selectedProperty
      );
      if (selectedPropertyObj) {
        setHouseChoices(
          selectedPropertyObj.houses.map((house) => house.house_no)
        );
        // setSelectedHouse(selectedPropertyObj.houses[0]?.house_no || "");
      }
    }
  }, [selectedProperty, properties]);

  const [selectedHouse, setSelectedHouse] = useState(houseChoices[0]);

  //input variables
  const [expenseTypeChoices, setExpenseTypeChoices] = useState([
    "Plumbing",
    "Electricity",
    "Painting",
    "Sewer",
    "Water",
    "Others",
  ]);
  const [selectedExpenseType, setSelectedExpenseType] = useState(
    expenseTypeChoices[0]
  );
  const [expenseDescription, setExpenseDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");

  //button variables
  const [isCancelButtonHovered, setIsCancelButtonHovered] = useState(false);
  const [isNextButtonHovered, setIsCreateButtonHovered] = useState(false);

  //methods
  const closeModal = () => {
    setShowModal(false);
  };

  const createPayment = () => {
    setIsCreateButtonHovered(false);
    // Validation logic
    if (
      selectedProperty === "Select Apartment" ||
      selectedHouse === "Select House" ||
      !selectedExpenseType ||
      !expenseDescription ||
      !amount ||
      !date
    ) {
      setToastType("warning");
      setShowToast(true);
      return;
    }

    const selectedPropertyObj = properties.find(
      (property) => property.name === selectedProperty
    );

    if (!selectedPropertyObj) {
      console.error("Selected property not found");
      return;
    }

    const selectedHouseObj = selectedPropertyObj.houses.find(
      (house) => house.house_no === selectedHouse
    );

    if (!selectedHouseObj) {
      console.error("Selected house not found");
      return;
    }

    const propertyId = selectedPropertyObj._id;
    const houseId = selectedHouseObj._id;

    const expenseTypeMap = {
      Electricity: 'electricity',
      Water: 'water',
      Plumbing: 'plumbing',
      Painting: 'painting',
      Sewer: 'sewer',
      Others: 'other',
    };

    const expenseDetails = {
      house_id: houseId,
      type: expenseTypeMap[selectedExpenseType],
      description: expenseDescription,
      amount,
      date,
    };
    dispatch(createExpense({ expenseDetails, propertyId })).then((res) => {
      console.log("the response", res)
      if (res?.payload?.status === "success") {
        setToastType("success");
        setShowToast(true);
        dispatch(getAllExpenses({ propertyId }));
        closeModal();
      }
    });
   
    
  };

  //styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: "20px 20px 20px 20px",
      borderRadius: "8px",
      width: "90%", // Adapt to smaller screens
      maxWidth: "500px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
      fontFamily: "Karla, sans-serif",
      overflowX: "hidden",
    },
    closeBtn: {
      position: "absolute",
      top: "10px",
      right: "15px",
      fontSize: "32px",
      fontWeight: "200",
      background: "none",
      border: "none",
      cursor: "pointer",
    },

    titles: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      marginBottom: "20px",
    },
    mainTitle: {
      fontSize: "24px",
      fontWeight: "700",
      marginBottom: "5px",
    },
    subTitle: {
      fontSize: "16px",
      fontWeight: "300",
      color: "#666",
    },
    textArea: {
      width: "100%",
      padding: "10px",
      marginBottom: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      fontSize: "16px",
    },
    inputContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
    },
    input: {
      width: "100%",
      padding: "10px",
      marginBottom: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      fontSize: "16px",
    },
    select: {
      width: "100%",
      padding: "10px",
      marginBottom: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      fontSize: "16px",
    },

    buttonsContainer: {
      marginTop: "20px",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
    },
    cancelButton: {
      width: "50%",
      padding: "10px",
      color: "white",
      borderRadius: "5px",
      backgroundColor: "#B39359",
      border: "none",
      cursor: "pointer",
      marginRight: "10px",
      transition: "background-color 0.3s ease",
    },
    cancelButtonHover: {
      backgroundColor: "#192A3A",
    },
    createButton: {
      width: "50%",
      padding: "10px",
      backgroundColor: "#192A3A",
      color: "white",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    createButtonHover: {
      backgroundColor: "#B39359",
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modalContent}>
        <button style={styles.closeBtn} onClick={closeModal}>
          &times;
        </button>
        <div style={styles.titles}>
          <div style={styles.mainTitle}>Create New Expense</div>
          <div style={styles.subTitle}>
            Fill in the following information to create a new expense
          </div>
        </div>

        <label>Apartment and House</label>
        <div style={styles.inputContainer}>
          <DropdownSelect
            choices={propertyChoices}
            defaultChoice={selectedProperty}
            onSelect={setSelectedProperty}
          />
          <DropdownSelect
            choices={houseChoices}
            defaultChoice={selectedHouse}
            onSelect={setSelectedHouse}
          />
        </div>
        <label>Expense Type</label>
        <DropdownSelect
          choices={expenseTypeChoices}
          defaultChoice={selectedExpenseType}
          onSelect={setSelectedExpenseType}
        />
        <label>Expense Description</label>
        <textarea
          style={styles.textArea}
          onChange={(e) => setExpenseDescription(e.target.value)}
          value={expenseDescription}
          rows="4"
          placeholder="E.g. fixed the leaking pipe in the kitchen"
        />

        <label>Amount</label>
        <input
          style={styles.input}
          type="number"
          placeholder="E.g. 500"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <label>Date</label>
        <input
          style={styles.input}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <div style={styles.buttonsContainer}>
          <button
            style={{
              ...styles.cancelButton,
              ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
            }}
            onClick={closeModal}
            onMouseEnter={() => setIsCancelButtonHovered(true)}
            onMouseLeave={() => setIsCancelButtonHovered(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            style={{
              ...styles.createButton,
              ...(isNextButtonHovered ? styles.createButtonHover : {}),
            }}
            onMouseEnter={() => setIsCreateButtonHovered(true)}
            onMouseLeave={() => setIsCreateButtonHovered(false)}
            onClick={() => {
              createPayment();
            }}
          >
            Create
          </button>
        </div>
      </div>
    
    </div>
  );
};

export default CreateExpenseModal;
